<template>
  <v-container fluid>
    <v-row>
      <v-col sm="4" md="3" lg="2" class="pa-0 hidden-xs-only">
        <SideMenu />
      </v-col>
      <v-col cols="12" sm="8" md="9" lg="10" class="nav-right pa-0 pl-sm-14 mt-10">
        <OrganizationProfileForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { userComputed } from "@/store/helpers.js";
import SideMenu from "@/components/SideMenu";
import OrganizationProfileForm from "@/components/OrganizationProfileForm";
import { meta } from "@/libs/mixins";

export default {
    props: ["noStepper"],

    components: {
        SideMenu,
        OrganizationProfileForm
    },

    mixins: [meta],

    metaInfo() {
        return this.getMetaInfo({
            title: `Perfil de ${ this.getUser.organization.name }`,
        });
    },
    
    computed: {
        ...userComputed,
    }

};
</script>
